module.exports = require("@bechtel/client-blocks");